import { ThemeModule } from '../../theme.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoPlayerComponent } from './video-player.component';
import { DurationPipe } from './duration.pipe';
import { MatSliderModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, MatSliderModule, TranslateModule, FormsModule, ReactiveFormsModule],
  declarations: [VideoPlayerComponent, DurationPipe],
  exports: [VideoPlayerComponent, DurationPipe],
})
export class VideoPlayerModule {}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/video-player/video-player.module.ts